import { BannersState } from './duck';
import { createSelector } from '~/helpers/util/selectors';

export const getRoot = (state: any) => {
  return state.core.banners as BannersState;
};

export const getById = createSelector([getRoot], state => state.byId);

export const getBanners = createSelector([getRoot], state =>
  Array.from(state.byId.values())
);
